import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IdbService } from '../idb/idb.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  // role observor
  private roleSubject = new BehaviorSubject<string>('');
  currentRole = this.roleSubject.asObservable();

  private offlineRoleSubject = new BehaviorSubject<boolean>(false);
  currentOfflineStatus = this.offlineRoleSubject.asObservable();

  public offlineRoles = [
    // 'Admin',
    'Estimator',
    'Foreman',
    'Service Tech',
    // 'Superintendent',
  ];

  constructor(
    private idb: IdbService,
    private localStorage: LocalStorageService
  ) {
    this.updateUserRole();
  }

  updateUserRole() {
    let uid = this.localStorage.get('uid');
    if (uid) {
      this.idb.getUserRole(uid).subscribe({
        next: (role) => {
          if (role) {
            this.roleSubject.next(role);
            this.updateOfflineStatus(role);
          }
        },
        error: (e) => {
          console.error(e);
        },
      });
    }
  }

  updateOfflineStatus(role: string) {
    if (this.offlineRoles.includes(role)) {
      this.offlineRoleSubject.next(true);
    } else {
      this.offlineRoleSubject.next(false);
    }
  }

  getCurrentUserRole(): string {
    return this.roleSubject.value;
  }

  getCurrentOfflineStatus(): boolean {
    return this.offlineRoleSubject.value;
  }
}
